<div class="tw-relative tw-pt-8 tw-pb-8">
  <div class="tw-absolute tw-top-3 tw-right-3 tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer" (click)="closeBottomSheet()">
    <img class="tw-w-6 tw-h-6" src="/assets/icons/close-icon-bottomsheet.png" alt="close" />
  </div>

  <div class="tw-flex tw-flex-col tw-items-center tw-gap-8">
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-5">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-w-[302px]">
        <div class="tw-w-[40px] tw-aspect-square tw-rounded-full tw-overflow-hidden tw-flex tw-justify-center tw-items-center">
          <img class="" src="/assets/gifs/tick-white-no-bg.gif" alt="tick" />
        </div>
        <p class="tw-font-lexend tw-font-bold tw-text-[24px] tw-leading-[28.8px] tw-text-black tw-text-center" i18n="@@paymentLinkActive">Payment link is active</p>
      </div>

      <div class="tw-flex tw-flex-col tw-items-center tw-bg-[#fdfae5] tw-rounded-[12px] tw-px-4 tw-py-3 tw-w-[312px]">
        <p class="tw-font-lexend tw-font-bold tw-text-[14px] tw-leading-[18px] tw-text-[#b57728] tw-text-center" i18n="@@anyoneCanPay">Anyone with this link can pay ₹{{orderSP | number}}</p>
        <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[16px] tw-text-gray-500 tw-text-center" i18n="@@notifyOncePayment">We'll notify you once the payment is done.</p>
      </div>
    </div>

    <div class="tw-flex tw-gap-2 md:tw-gap-4 tw-items-start tw-w-[312px]">
      <button csButton="outlined"
              type="button"
              class="tw-flex-1"
              style="border-radius: 12px !important; border-color: #0e796c !important; border-width: 1.3px !important; color: #0e796c !important;"
              (click)="onShareAgain()"
              i18n="@@shareAgain"
      > Share Again </button>
      <button csButton
              type="button"
              class="tw-flex-1"
              style="border-radius: 12px !important;"
              (click)="onCopyLink()"
              i18n="@@copyLink"
      >Copy link</button>
    </div>
  </div>
</div>
